<div class="header-container">
  <div class="creation-time">
    <div class="is-starred" *ngIf="viewModel?.isStarred" pTooltip="Starred" tooltipPosition="bottom" tooltipStyleClass="u-tooltip"></div>
    <p data-cy="mail-preview-time">{{ viewModel?.creationTime }}</p>
    <u-icon
      *ngIf="indicatorIcon.value"
      class="indicator-icon"
      [model]="indicatorIcon"
      [styles]="{ width: '16px', height: '16px' }"
    ></u-icon>
  </div>
  <div class="details">
    <div class="details-user">
      <div class="profile">
        <div
          data-cy="mail-preview-avatar"
          *ngIf="profile?.color; else avatar"
          class="profile-color"
          [ngStyle]="{ 'background-color': profile?.color }"
        >
          {{ viewModel?.sender?.text?.[0] }}
        </div>
        <ng-template #avatar><avatar *ngIf="profile?.url" [url]="profile?.url" [size]="'36px'"></avatar></ng-template>
      </div>
      <div class="names">
        <result-title
          data-cy="mail-preview-sender"
          class="sender-name"
          #title
          [model]="viewModel?.sender"
          [displayTooltip]="false"
          [showSingleLineView]="true"
          (click)="copySenderEmail()"
          [pTooltip]="viewModel?.sender.tooltip"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
          [ngClass]="{ focused: methodsList[markedIndex]?.id === 'title' }"
        >
        </result-title>
        <div class="recipients-container" *ngIf="viewModel?.recipients">
          <p>To:</p>
          <div *ngFor="let recipient of viewModel?.recipients.slice(0, countViewRecipients); index as i" class="recipients">
            <span
              (mousedown)="copyRecipientEmailAddress($event, recipient)"
              class="recipient-name"
              [pTooltip]="recipient.mail"
              tooltipPosition="top"
              tooltipStyleClass="u-tooltip"
              [ngClass]="{ focused: methodsList[markedIndex]?.id === 'recipient' + i }"
            >
              <div class="name" data-cy="mail-preview-recipient">{{ recipient.name ? recipient.name : recipient.mail }}</div>
              <div *ngIf="i < countViewRecipients - 1">,</div>
            </span>
          </div>
          <div *ngIf="viewModel?.recipients?.length > countViewRecipients">
            <u-icon
              #icon
              (click)="openRecipientsPopup()"
              [style]="{ 'font-weight': 600 }"
              [model]="{ type: 'font', value: 'icon-chevron-down' }"
              [ngClass]="{ focused: methodsList[markedIndex]?.id === 'icon' }"
            ></u-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <u-icon
        *ngIf="isAvailableSummary(model?.action)"
        class="open-icon summary"
        (click)="onSummary($event)"
        [model]="INDICATE_SUMMARY_ICON"
        pTooltip="Show summary"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
      ></u-icon>
      <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
        <u-icon
          *ngIf="model?.isFavorite"
          class="favorite"
          [model]="{ type: 'font', value: 'icon-star-solid' }"
          [styles]="{ width: '12px', height: '11.71px', color: 'var(--color-text-tertiary)' }"
        ></u-icon>
      </ng-container>
      <u-buttons
        data-cy="mail-preview-open-btn"
        #openIcon
        pTooltip="Open"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
        (onClick)="open()"
        type="secondary"
        class="open-icon"
        [ngClass]="{ focused: methodsList[markedIndex]?.id === 'open' }"
      >
        <u-icon [model]="{ type: 'font', value: 'icon-launch' }"></u-icon>
      </u-buttons>
      <square-button
        data-cy="mail-preview-square-btn"
        #actions
        [ngClass]="{ focused: methodsList[markedIndex]?.id === 'actions' }"
        [active]="contextMenuHelper?.source === 'actions'"
        (click)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        >•••</square-button
      >
    </div>
  </div>
  <div data-cy="mail-preview-title" class="title" (click)="open()" [innerHTML]="viewModel?.title?.text"></div>
  <div class="labels">
    <result-tag
      data-cy="mail-preview-tag"
      *ngFor="let label of viewModel?.labels"
      [model]="label"
      [defaultBackgroundColor]="'var(--primary-400)'"
      [dragMetadata]="dragMetadata"
      click-invoker
      #tags
    ></result-tag>
  </div>
  <div class="divider"></div>
</div>
